import React, { useCallback, useMemo, useState } from 'react';
import IDHelpers from '../../../../core/helpers/IDHelper';
import { Container, Content, ContentWrapper } from '../../common/TabsStyled';
// import ReinforcementCard from './ReinforcementCard';
import ReinforcementCard from './ReinforcementCard';
import { Grid } from '../Styles/ReinforcementsViewStyle';
// import { REINFORCEMENTS_CATEGORIES } from '../../events/constants';
import EmptyState from './EmptyState';
import Spinner from '../../../components/Spinner';
import { INITIAL_TAB } from '../constants';
import Navigation from './Navigation';
import ReinforcementFilter from './ReinforcementFilter';
import {
  Container as ContainInscription,
  Title as TitleInscription,
  Block
} from '../../events/components/body/inscriptions/InscriptionsStyled';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

interface BodyViewProps {
  courses: any[];
  selectReinforcement: (id: string, courseId: string) => void;
  reinforcementCards: {
    reinforcements: any[];
    featureds: any[];
    subscriptions: number;
    eventsWaitingList: any[];
  };
  setSelectCourse: (courseId: string) => void;
  selectedCourse: string;
  isLoadingReinforcements: boolean;
  courseIndex: number;
  selectIndex: (courseId: number) => void;
}

const BodyView = (props: BodyViewProps) => {
  const {
    courses,
    selectReinforcement,
    reinforcementCards,
    setSelectCourse,
    selectedCourse,
    isLoadingReinforcements,
    courseIndex,
    selectIndex
  } = props;
  const [tabs] = useState([INITIAL_TAB, ...courses]);
  const [isFirstTabActive, setIsFirstTabActive] = useState(
    selectedCourse === tabs[0]?.id
  );
  const toggleTab = (id: string) => {
    setSelectCourse(id);
  };

  const [selected, setSelected] = useState('Todos');
  const [selectModality, setSelectModality] = useState('');
  const [checked, setChecked] = useState(false);

  const filteredCards = useMemo(() => {
    // parte base
    let cards = reinforcementCards?.featureds ?? [];
    // filtro por tipo
    if (selected !== 'Todos') {
      cards = cards.filter((f) => f.type?.code === selected);
    }
    // filtro por modalidad
    if (selectModality) {
      cards = cards.filter((f) => f.modality?.code === selectModality);
    }
    // filtro de vacantes si está chequeado
    if (checked) {
      cards = cards.filter((f) => (f.vacancies ?? 0) > 0);
    }
    return cards;
  }, [reinforcementCards?.featureds, selected, selectModality, checked]);

  const changeCheckbox = useCallback(() => {
    GoogleAnalytics.writeLog('portal-services-checkboxEvents', 'services');
    setChecked((prev) => !prev);
  }, []);
  return (
    <Container data-testid="cmp-reinforments-body-view">
      <Navigation
        tabs={tabs}
        courseIdState={selectedCourse}
        toggleTab={toggleTab}
        subscriptions={reinforcementCards?.subscriptions}
        selectIndex={selectIndex}
        courseIndex={courseIndex}
        setIsFirstTabActive={setIsFirstTabActive}
      />
      <ContentWrapper>
        {isLoadingReinforcements ? (
          <Spinner />
        ) : (
          <Content className="content active-content">
            {/* {selectedCourse !== INITIAL_TAB.id && */}
            {!isFirstTabActive && reinforcementCards?.featureds?.length > 0 && (
              <ReinforcementFilter
                selected={selected}
                setSelected={setSelected}
                selectModality={selectModality}
                setSelectModality={setSelectModality}
                numberOfResults={filteredCards.length}
                changeCheckbox={changeCheckbox}
              />
            )}
            {selectedCourse === INITIAL_TAB.id && (
              <ContainInscription>
                <Block>
                  <TitleInscription>Mis refuerzos inscritos</TitleInscription>
                  {reinforcementCards?.reinforcements?.length > 0 && (
                    <Grid>
                      {reinforcementCards.reinforcements.map((card) => (
                        <ReinforcementCard
                          courseId={selectedCourse}
                          cardInfo={card}
                          selectReinforcement={selectReinforcement}
                          key={IDHelpers.generateID()}
                        />
                      ))}
                    </Grid>
                  )}
                  {reinforcementCards?.reinforcements?.length === 0 && (
                    <EmptyState text="¡Empieza a inscribirte en tu primer refuerzo!" />
                  )}
                </Block>
              </ContainInscription>
            )}
            {reinforcementCards?.eventsWaitingList?.length > 0 && (
              <Block>
                <TitleInscription>Lista de espera</TitleInscription>
                <div data-testid="waitingList" style={{ width: '100%' }}>
                  <Grid>
                    {reinforcementCards.eventsWaitingList.map((card) => (
                      <ReinforcementCard
                        courseId={selectedCourse}
                        cardInfo={card}
                        selectReinforcement={selectReinforcement}
                        key={IDHelpers.generateID()}
                      />
                    ))}
                  </Grid>
                </div>
              </Block>
            )}
            {filteredCards?.length > 0 ? (
              <Block>
                {selectedCourse === INITIAL_TAB.id && (
                  <TitleInscription>Refuerzos destacados</TitleInscription>
                )}
                <div data-testid="InscriptionsView" style={{ width: '100%' }}>
                  <Grid>
                    {filteredCards?.map((card) => (
                      <ReinforcementCard
                        courseId={selectedCourse}
                        cardInfo={card}
                        selectReinforcement={selectReinforcement}
                        key={IDHelpers.generateID()}
                      />
                    ))}
                  </Grid>
                </div>
              </Block>
            ) : (
              <>
                {selectedCourse ? (
                  <EmptyState
                    text={'La búsqueda no obtuvo ningún resultado.'}
                    notFoundReinforcements
                  />
                ) : (
                  // <EmptyState
                  //   text={'¡Empieza a inscribirte en tu primer refuerzo!'}
                  // />
                  <></>
                )}
              </>
            )}
          </Content>
        )}
      </ContentWrapper>
    </Container>
  );
};

export default BodyView;
